import $ from 'jquery';

const secKV = function () {
    const $section = $("#ASUS-features .section__kv");
    const $kvContainer = $("#ASUS-features .section__kv .kv-container");
    const $infoContainer = $("#ASUS-features .section__kv .info-container");

    // 获取各自的高度
    const kvContainerHeight = $kvContainer.outerHeight();
    const infoContainerHeight = $infoContainer.outerHeight();

    // 计算 section 的总高度
    const sectionHeight = kvContainerHeight + infoContainerHeight;

    // 计算各自的半高
    const halfKvContainerHeight = kvContainerHeight / 2;
    const halfInfoContainerHeight = infoContainerHeight / 2;

    const $kvWindow = $(window);
    // const sectionHeight = $section.outerHeight(); // 獲取 section 的高度
    const halfSectionHeight = sectionHeight / 2; // 將高度除以二
    const SectionHeightFor = halfKvContainerHeight + halfInfoContainerHeight + 200;

    // console.log(sectionHeight, halfSectionHeight, SectionHeightFor);

    setTimeout(() => {
        $section.addClass('active');
    }, 1000);
    

    $kvWindow.on("resize scroll", function(){
        $section.each(function () {
            let sectionTop = $(this).offset().top;
            let sectionBottom = sectionTop + $(this).outerHeight();
            let scrollTop = $kvWindow.scrollTop();

            let kvWindowHeight = $kvWindow.innerHeight();
            let infoContainerMoveY = scrollTop - kvWindowHeight;

            if(scrollTop >= SectionHeightFor) {
                $infoContainer.css({'position': 'relative'});
            } else {
                $infoContainer.removeAttr('style');
            }
            // console.log(scrollTop, halfSectionHeight);
            // $kvContainer.css({
            //     'transform': 'translateY(-' + scrollTop + 'px)'
            // });

            // $infoContainer.css({
            //     'transform': 'translateY(' + infoContainerMoveY + 'px)'
            // });

            // console.log(scrollTop, halfSectionHeight, sectionTop, sectionBottom);
        });
    });
    
}
export default secKV;

